import Icon from '../../../components/AppIcon';

const CostSummaryCards = ({ summaryData }) => {
  const cards = [
    {
      title: 'Total Costs',
      value: `$${summaryData?.totalCosts?.toLocaleString('en-AU', { minimumFractionDigits: 2 })}`,
      change: '+12.5%',
      trend: 'up',
      icon: 'DollarSign',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      title: 'Pending Approval',
      value: summaryData?.pendingApproval,
      change: '-8 from last month',
      trend: 'down',
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      title: 'Approved This Month',
      value: summaryData?.approvedMonth,
      change: '+15.3%',
      trend: 'up',
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      title: 'Reimbursements Due',
      value: `$${summaryData?.reimbursementsDue?.toLocaleString('en-AU', { minimumFractionDigits: 2 })}`,
      change: '12 pending',
      trend: 'neutral',
      icon: 'RefreshCw',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {cards?.map((card, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-shadow">
          <div className="flex items-start justify-between mb-3">
            <div className={`w-10 h-10 rounded-lg ${card?.bgColor} flex items-center justify-center`}>
              <Icon name={card?.icon} size={20} className={card?.color} />
            </div>
            <div className={`flex items-center gap-1 text-xs ${
              card?.trend === 'up' ? 'text-success' : 
              card?.trend === 'down'? 'text-error' : 'text-muted-foreground'
            }`}>
              {card?.trend === 'up' && <Icon name="TrendingUp" size={14} />}
              {card?.trend === 'down' && <Icon name="TrendingDown" size={14} />}
              <span>{card?.change}</span>
            </div>
          </div>
          <h3 className="text-2xl font-bold text-foreground mb-1">{card?.value}</h3>
          <p className="text-sm text-muted-foreground">{card?.title}</p>
        </div>
      ))}
    </div>
  );
};

export default CostSummaryCards;